import 'bootstrap/dist/js/bootstrap.bundle.min.js'

/**
 * Plugin para configurar e inicializar o Bootstrap na aplicação Vue/Nuxt.
 * Este plugin importa o pacote JavaScript do Bootstrap e o disponibiliza
 * na aplicação, permitindo o uso de componentes e funcionalidades do Bootstrap.
 * @returns Um objeto NuxtPlugin configurado para Bootstrap.
 */
export default defineNuxtPlugin(() => {
  // Qualquer configuração adicional para o Bootstrap pode ser adicionada aqui.
})
